import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { localized } from "js/includes/common/utils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSpinner, faCheck, faUpload, faTimes } from "@fortawesome/pro-solid-svg-icons"

export default class FileSelector extends PureComponent {
  static defaultProps = {
    percentage: 0,
    isUploading: false,
    uploadFailure: false,
    uploadSucceeded: false,
  }

  static propTypes = {
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onUpload: PropTypes.func,
    percentage: PropTypes.number,
  }

  state = {
    fileSelected: false,
  }

  onSelectFile = () => {
    this.input.click()
  }

  onChange = e => {
    const { onChange } = this.props
    const file = e.target.files[0]

    this.setState({
      fileSelected: !!file,
    })

    onChange(file)
  }

  render() {
    const {
      label = localized("general.selectAFile"),
      onUpload,
      percentage,
      accept,
      isUploading,
      uploadFailure,
      uploadSucceeded,
    } = this.props
    const { fileSelected } = this.state

    return (
      <div className="file-selector-container">
        <input
          style={{
            width: 0,
            height: 0,
            position: "absolute",
          }}
          type="file"
          className="editor-install-inputfile"
          accept={accept}
          onChange={this.onChange}
          ref={r => (this.input = r)}
          disabled={isUploading}
        />

        <div className="label-container">
          {onUpload && (
            <div
              className={`progress-bar ${uploadFailure ? "progress-bar-danger" : ""}`}
              style={{ width: `${percentage}%` }}
            >
              {uploadFailure && localized("general.error")}
              {uploadSucceeded && localized("infrastructure.rivetsExtensions.uploadComplete")}
            </div>
          )}

          <div className="browse" onClick={this.onSelectFile} />

          <input disabled type="text" value={label} />
        </div>

        {onUpload && (
          <button
            disabled={isUploading}
            type="submit"
            className={`btn ${uploadFailure ? "btn-danger" : "btn-success"} btn-sm mt-2 editor-install-upload-btn2 ${
              fileSelected ? "slide-in" : "slide-out"
            }`}
            onClick={onUpload}
          >
            {percentage >= 100 ? (
              <FontAwesomeIcon icon={faCheck} />
            ) : uploadFailure ? (
              <FontAwesomeIcon icon={faTimes} />
            ) : percentage > 0 && percentage < 100 ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              <FontAwesomeIcon icon={faUpload} />
            )}
            {percentage ? ` ${percentage} %` : " Upload"}
          </button>
        )}
      </div>
    )
  }
}
